import React, { useContext } from "react";
import PropTypes from "prop-types";
import { DialogActions, Grid, Typography } from "@mui/material";
import EMPButton from "../../EMPButton/EMPButton";
import { ModalContext } from "../ModalContext";

const SimpleErrorMessage = ({ error }) => {
  const { handleModal } = useContext(ModalContext);

  const handleClose = () => {
    handleModal(false, false);
  };

  return (
    <div>
      <Typography variant="body1" sx={{ mb: 6 }}>
        {error}
      </Typography>

      <DialogActions sx={{ padding: "16px 0" }}>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <EMPButton variant="contained" onClick={handleClose}>
              Close
            </EMPButton>
          </Grid>
        </Grid>
      </DialogActions>
    </div>
  );
};

SimpleErrorMessage.propTypes = {
  error: PropTypes.node.isRequired,
};

export default SimpleErrorMessage;
